/**
 * Canonical Insights page chrome copy (UX-DR10, docs/ui-book/pages/insights.md §2).
 * Keep in sync with ui-book. Regression: `StatisticsPage.test.tsx` asserts literals from
 * the same doc section — do not point tests at this module or drift from ui-book goes green.
 */
export const INSIGHTS_PAGE_CHROME = {
    eyebrow: 'Intelligence Bureau',
    title: 'Insights & Analytics',
    subtitle: 'Deep-dive framing for entities, decisions, and domain health',
} as const;
